import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Shield, Monitor, Headphones, Lock, Eye, AlertTriangle } from 'lucide-react';

const securityFeatures = [
  {
    icon: Lock,
    title: "Cifrado Avanzado",
    description: "Protocolos de cifrado de última generación para máxima seguridad."
  },
  {
    icon: Eye,
    title: "Monitoreo en Tiempo Real",
    description: "Sistema antifraude que supervisa cada transacción las 24 horas."
  },
  {
    icon: AlertTriangle,
    title: "Autenticación Múltiple",
    description: "Verificación de múltiples factores para protección adicional."
  }
];

const platformFeatures = [
  {
    icon: Monitor,
    title: "Dashboard Web",
    description: "Plataforma web completa para gestión avanzada y reportes."
  },
  {
    icon: Shield,
    title: "Panel de Control",
    description: "Interfaz intuitiva para administrar todas tus operaciones financieras."
  },
  {
    icon: Headphones,
    title: "Soporte Especializado",
    description: "Atención personalizada 24/7 con expertos en soluciones financieras."
  }
];

export const TechnologySection = () => {
  return (
    <section id="tecnologia" className="py-20 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Technology & Security */}
        <div className="mb-20">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">
              Tecnología y Seguridad
            </h2>
            <p className="text-xl text-slate-300 max-w-4xl mx-auto leading-relaxed">
              En NOVOPAY la seguridad es prioridad. Implementamos protocolos de cifrado avanzado, autenticación de 
              múltiples factores y un sistema antifraude que monitorea cada transacción en tiempo real. Protegemos 
              tus recursos con los más altos estándares internacionales.
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            {securityFeatures.map((feature, index) => (
              <Card key={index} className="group hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-slate-800 bg-slate-900 text-white">
                <CardHeader className="text-center pb-4">
                  <div className="w-16 h-16 bg-yellow-500/20 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-yellow-500/30 transition-colors duration-300">
                    <feature.icon className="h-8 w-8 text-yellow-400" />
                  </div>
                  <CardTitle className="text-xl font-bold group-hover:text-yellow-400 transition-colors duration-300">
                    {feature.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="text-center">
                  <p className="text-slate-300 leading-relaxed">
                    {feature.description}
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>

        {/* Platform 360° */}
        <div className="bg-slate-900 border border-slate-800 rounded-2xl p-8 md:p-12">
          <div className="text-center mb-12">
            <h3 className="text-2xl sm:text-3xl font-bold text-white mb-4">
              Plataforma 360°
            </h3>
            <p className="text-xl text-slate-300 max-w-3xl mx-auto">
              Nuestra plataforma integral ofrece todo lo que necesitas para manejar tu dinero desde un solo lugar. 
              Dashboard web, panel de control y soporte especializado se combinan para ofrecerte una experiencia 
              completa y sin límites.
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            {platformFeatures.map((feature, index) => (
              <Card key={index} className="text-center hover:shadow-lg transition-all duration-300 border border-slate-800 bg-black">
                <CardHeader className="pb-4">
                  <div className="w-16 h-16 bg-yellow-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
                    <feature.icon className="h-8 w-8 text-yellow-400" />
                  </div>
                  <CardTitle className="text-xl font-bold text-white">
                    {feature.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-slate-300 leading-relaxed">
                    {feature.description}
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
